import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import {
  SecureDocumentUploadsRequest,
  SecureDocumentUploadsResponse,
} from "../request/SecureDocumentUploadsRequest";

const SecureDocumentUploadsApiService = async (
  request: SecureDocumentUploadsRequest
): Promise<SecureDocumentUploadsResponse> => {
  const url = "/utils/generate_url_for_secure_upload/";
  const fileData = new FormData();
  // eslint-disable-next-line
  // @ts-ignore
  Object.keys(request).forEach((it) => fileData.append(it, request[it]));
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const { data } = await axios.post(url, fileData, config);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSecureDocumentUploadsApiService = () =>
  useMutation<
    SecureDocumentUploadsResponse,
    AxiosError,
    SecureDocumentUploadsRequest
  >(SecureDocumentUploadsApiService, {
    mutationKey: ["SecureDocumentUploadsApiService"],
  });

export default useSecureDocumentUploadsApiService;
